"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ChevronRightIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "10",
  height: "17",
  viewBox: "0 0 10 17",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-579.000000, -237.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(584.000000, 245.500000) scale(-1, 1) translate(-584.000000, -245.500000) translate(581.000000, 238.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.200000, -1.363636)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M9.99279265,4.44553626 C10.4831818,3.93893591 11.2421198,3.98000398 11.6879281,4.53726437 C12.0994435,5.05165858 12.1003047,5.82607856 11.7122979,6.34063124 L11.6072074,6.46355465 L5.00720735,13.2817365 C4.587644,13.7151697 3.96532306,13.7512891 3.51196678,13.3900948 L3.39279265,13.2817365 L-3.20720735,6.46355465 C-3.69759649,5.95695429 -3.7337364,5.09452476 -3.28792809,4.53726437 C-2.87641272,4.02287017 -2.19808864,3.94830847 -1.71046175,4.33833609 L-1.59279265,4.44553626 L4.2,10.4304545 L9.99279265,4.44553626 Z",
            fillRule: "nonzero",
            transform: "translate(4.200000, 8.863632) rotate(90.000000) translate(-4.200000, -8.863632)"
          })
        })
      })
    })
  })]
});

ChevronRightIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ChevronRightIcon;
exports.default = _default;